// Backend timestamps (e.g. "2026-07-15T11:01:36.15") carry no zone marker but are
// actually UTC instants. Anchor them explicitly so callers display them in the
// viewer's own local time zone instead of having the browser assume local time.
export function apiTimestampToDate(iso) {
  if (!iso) return null;
  if (/Z$|[+-]\d{2}:?\d{2}$/.test(iso)) return new Date(iso);
  return new Date(iso.includes('T') ? `${iso}Z` : iso);
}

export function fmtDate(iso) {
  if (!iso) return '—';
  const d = apiTimestampToDate(iso);
  return d.toLocaleString('en-US', { month: 'short', day: 'numeric', hour: '2-digit', minute: '2-digit' });
}

export function fmtRelative(iso) {
  if (!iso) return '—';
  const diffSec = Math.max(0, Math.round((Date.now() - apiTimestampToDate(iso).getTime()) / 1000));
  if (diffSec < 60) return 'just now';
  const diffMin = Math.round(diffSec / 60);
  if (diffMin < 60) return `${diffMin}m ago`;
  const diffHr = Math.round(diffMin / 60);
  if (diffHr < 24) return `${diffHr}h ago`;
  const diffDay = Math.round(diffHr / 24);
  if (diffDay < 30) return `${diffDay}d ago`;
  return fmtDate(iso);
}

// Same shape as the old per-file `formatDate` helpers (ProjectSelectPage,
// AdminProjectsPage, SourceTreePage, StandardsPage): "17 Jul 2026, 02:15 PM".
export function formatDate(iso) {
  if (!iso) return '—';
  const d = apiTimestampToDate(iso);
  const date = d.toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' });
  const time = d.toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit', hour12: true });
  return `${date}, ${time}`;
}
